"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DataTable = _interopRequireDefault(require("../../../../../data-table/DataTable"));

var _checkbox = _interopRequireDefault(require("britive-design-system/core/components/checkbox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Identities = function Identities(_ref) {
  var data = _ref.data,
      selectedIdentities = _ref.selectedIdentities,
      setSelectedIdentities = _ref.setSelectedIdentities,
      identityType = _ref.identityType,
      translatedStrings = _ref.translatedStrings;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      filteredRows = _useState2[0],
      setFilteredRows = _useState2[1];

  var handleLocalSearch = function handleLocalSearch(value) {
    if (!value) {
      setFilteredRows(null);
      return;
    }

    var filteredData = data.filter(function (_ref2) {
      var name = _ref2.name;
      return name.toLowerCase().includes(value.toLowerCase());
    });
    setFilteredRows(filteredData);
  };

  var renderCheckbox = function renderCheckbox(row, propertyName) {
    var itemIndex = selectedIdentities.findIndex(function (identity) {
      return identity.userId === row.userId;
    });
    var isChecked = itemIndex > -1;
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex'
      }
    }, /*#__PURE__*/_react.default.createElement(_checkbox.default, {
      name: "checkbox-".concat(row.userId),
      checked: isChecked,
      onChange: function onChange(e) {
        var isItemChecked = e.target.checked;

        if (isItemChecked && !isChecked) {
          setSelectedIdentities([].concat(_toConsumableArray(selectedIdentities), [row]));
        } else if (isChecked) {
          var clonedSelectedItems = JSON.parse(JSON.stringify(selectedIdentities));
          clonedSelectedItems.splice(itemIndex, 1);
          setSelectedIdentities(clonedSelectedItems);
        }
      }
    }), "\xA0", row[propertyName]);
  };

  var columns = identityType === translatedStrings.userLabel ? [{
    field: 'firstName',
    headerName: 'First Name',
    width: '20%',
    renderColumn: function renderColumn(row) {
      return renderCheckbox(row, "firstName");
    }
  }, {
    field: 'lastName',
    headerName: 'Last Name',
    width: '20%'
  }, {
    field: 'username',
    headerName: 'Username',
    width: '20%'
  }, {
    field: 'email',
    headerName: 'Email',
    width: '25%'
  }, {
    field: 'status',
    headerName: 'Status',
    width: '15%'
  }] : [{
    field: 'name',
    headerName: 'Name',
    width: '35%',
    renderColumn: function renderColumn(row) {
      return renderCheckbox(row, "name");
    }
  }, {
    field: 'description',
    headerName: 'Description',
    width: '45%'
  }, {
    field: 'status',
    headerName: 'Status',
    width: '20%'
  }];
  return /*#__PURE__*/_react.default.createElement(_DataTable.default, {
    rows: filteredRows || data,
    loadMore: false,
    loading: false,
    inLineSort: true,
    searchBar: {
      onSearch: handleLocalSearch,
      placeholder: 'Search'
    },
    columns: columns
  });
};

Identities.propTypes = {
  data: _propTypes.default.array,
  selectedIdentities: _propTypes.default.array,
  setSelectedIdentities: _propTypes.default.func,
  identityType: _propTypes.default.string,
  translatedStrings: _propTypes.default.object
};
var _default = Identities;
exports.default = _default;